import apiService from './apiService';

export async function fetchRegion(id: string) {
  const response = await apiService.get(`regions/${id}`);
  return response?.data;
}
